export const CATEGORIES = [
  {
    slug: "pisos",
    label: "Pisos",
    tagline: "Habitaciones y viviendas para compartir",
    description:
      "Habitaciones, pisos completos o mesas de estudio para compartir contigo o entre estudiantes y profesionales.",
    image:
      "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1600&q=85",
    accent: "#3E6BB5",
    active: true,
  },
  {
    slug: "viajes",
    label: "Viajes",
    tagline: "Coche compartido, rutas y escapadas",
    description:
      "Comparte trayectos, plazas de coche o rutas de fin de semana con personas que van en tu misma dirección.",
    image:
      "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?auto=format&fit=crop&w=1600&q=85",
    accent: "#2E4E9E",
    active: false,
  },
  {
    slug: "idiomas",
    label: "Idiomas",
    tagline: "Intercambio y práctica de idiomas",
    description:
      "Encuentra tándems, grupos de conversación y compañeros para practicar idiomas cerca de ti o en línea.",
    image:
      "https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=1600&q=85",
    accent: "#4C7EBF",
    active: false,
  },
  {
    slug: "eventos",
    label: "Actividades",
    tagline: "Planes, quedadas y eventos sociales",
    description:
      "Comparte entradas, organiza quedadas y descubre eventos culturales, deportivos o sociales cerca de ti.",
    image:
      "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1600&q=85",
    accent: "#375AA0",
    active: false,
  },
  {
    slug: "negocios",
    label: "Ideas",
    tagline: "Emprender, colaborar y compartir negocio",
    description:
      "Comparte ideas, busca socios, coworkings, servicios y oportunidades de colaboración entre emprendedores.",
    image:
      "https://images.unsplash.com/photo-1497215842964-222b430dc094?auto=format&fit=crop&w=1600&q=85",
    accent: "#1E3A8A",
    active: false,
  },
  {
    slug: "objetos",
    label: "Clasificados",
    tagline: "Segunda mano, intercambio y oportunidades",
    description:
      "Anuncios clasificados: compra, vende, intercambia o dona artículos y aprovecha oportunidades con personas cercanas.",
    image:
      "https://images.unsplash.com/photo-1489367874814-f5d040621dd8?auto=format&fit=crop&w=1600&q=85",
    accent: "#6D89B8",
    active: false,
  },
  {
    slug: "servicios",
    label: "Profesión",
    tagline: "Comparte tu profesión o servicio",
    description:
      "Ofrece o encuentra servicios profesionales y particulares: mudanzas, limpieza, cuidados, reformas, tu propio negocio.",
    image:
      "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1600&q=85",
    accent: "#5A79B0",
    active: false,
  },
  {
    slug: "empleo",
    label: "Descuentos",
    tagline: "Chollos, cupones y oportunidades de ahorro",
    description:
      "Comparte y descubre descuentos, cupones, ofertas y oportunidades para ahorrar en el día a día.",
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1600&q=85",
    accent: "#1E4A8C",
    active: false,
  },
];

export function isCategoryActive(slug) {
  return CATEGORIES.find((c) => c.slug === slug)?.active === true;
}

export const ACTIVE_CATEGORIES = CATEGORIES.filter((c) => c.active);
export const INACTIVE_CATEGORIES = CATEGORIES.filter((c) => !c.active);

export const FEATURED_HERO_CATEGORIES = ["viajes", "pisos", "idiomas", "negocios"];

export function categoryBadgeClass(slug) {
  switch (slug) {
    case "viajes": return "cat-viajes";
    case "pisos": return "cat-pisos";
    case "idiomas": return "cat-idiomas";
    case "negocios": return "cat-negocios";
    case "empleo": return "cat-empleo";
    case "servicios": return "cat-servicios";
    case "objetos": return "cat-objetos";
    case "eventos": return "cat-eventos";
    case "deporte": return "cat-deporte";
    default: return "cat-viajes";
  }
}

export function categoryLabel(slug) {
  return CATEGORIES.find((c) => c.slug === slug)?.label || slug;
}

export function categoryAccent(slug) {
  return CATEGORIES.find((c) => c.slug === slug)?.accent || "#3B5FB8";
}

// Common countries for the picker (Spanish labels)
export const COUNTRIES = [
  "España",
  "Portugal",
  "Francia",
  "Italia",
  "Alemania",
  "Reino Unido",
  "México",
  "Argentina",
  "Colombia",
  "Chile",
  "Perú",
  "Estados Unidos",
  "Otro",
];
